




















































































import Vue from 'vue'
import Navigation from '@/components/common/Navigation.vue'
import NewProductCard from '@/components/product/NewProductCard.vue'
import UpsellBundle from '@/components/product/UpsellBundle.vue'
import LibraryShimmer from '@/components/common/LibraryShimmer.vue'
import { UserPurchaseService } from '@/services'
import Product from '../models/Product'
import UniversalSearch from '@/components/common/UniversalSearch.vue'
import UpsellOffer from '@/models/UpsellOffer'
export default Vue.extend({
  components: {
    UpsellBundle,
    Navigation,
    NewProductCard,
    LibraryShimmer,
    UniversalSearch
  },
  data() {
    return {
      products: [] as Product[],
      fetching: false,
      showSearchModal: false,
      upsellOffers: [] as UpsellOffer[],
      allCourses: [],
      purchasedProductIds: [],
      active: 'All Courses'
    }
  },
  async mounted() {
    this.$bus.$on('openSearchModal', this.openSearchModal)
    await this.fetchUserProducts()
    await this.fetchUpsellBundle()
  },
  methods: {
    async fetchUserProducts() {
      this.fetching = true

      try {
        this.products = await UserPurchaseService.getAllProducts()
        this.purchasedProductIds = this.products.map(p => p.id)
      } catch (error) {
        console.error('Error while fetching products --> ', error)
      } finally {
        this.fetching = false
      }
    },
    openProduct(productId) {
      this.$router.push({
        name: 'product-overview',
        params: { id: productId }
      })
    },
    async fetchUpsellBundle() {
      try {
        const upsellOffers = await UserPurchaseService.getBundleOffers()
        const set = new Set()
        this.upsellOffers = upsellOffers.filter(offer => {
          if (!set.has(offer.upsellOfferId)) {
            set.add(offer.upsellOfferId)
            return true
          }
          return false
        })
        this.allCourses = [...this.upsellOffers, ...this.products]
      } catch (error) {
        console.error('Error while fetching upsell bundles --> ', error)
      }
    },
    openSearchModal(value: boolean) {
      this.showSearchModal = value
    }
  }
})
